import { useToggle } from 'shared/hooks';

const useSearchBar = (startOpen = false) => {
  const { on: folded, toggle } = useToggle(!startOpen);

  return {
    folded,
    toggle,
  };
};

export { useSearchBar };
